import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import AXIOS from "../../../config/api";
import { BASE_API } from "../../../constants/apiUrls";
import { toast } from "../../../lib/toast";
import {
  CommonOthers,
  ErrorMessage,
  GetCommonData,
  GetSingleDataParams,
  Params,
  PostRequest,
} from "../../../types";
import {
  CreateContentData,
  GetContentData,
  GetContentDataParams,
  GetSingleContentData,
} from "../../../types/contentManagment/contentManagment";
import { handleApiError } from "../../../utils/errorHandler";

// create
export const createPublicationAsync = createAsyncThunk<
  null,
  PostRequest<CreateContentData, CommonOthers>
>(
  "admin/createPublication",
  async ({ data, others: { reRender } }, { rejectWithValue }) => {
    try {
      await AXIOS.post(BASE_API.createPublication, data, {
        headers: {},
      });

      reRender(true);
      toast("success", "Publication create successfully");
      return null;
    } catch (err) {
      const errors = err as AxiosError;
      const error = errors.response?.data as ErrorMessage;
      handleApiError(error, "Publication create fail");
      return rejectWithValue(error);
    }
  }
);

// get all
export const getAllPublicationAsync = createAsyncThunk<
  GetCommonData<GetContentData>,
  Params<GetContentDataParams>,
  {
    rejectValue: ErrorMessage;
  }
>("admin/getAllDivision", async ({ params }, { rejectWithValue }) => {
  const { ...rest } = params as GetContentDataParams;

  try {
    const data = await AXIOS.get(BASE_API.getAllPublication, {
      params: { ...rest },
      headers: {
        "ngrok-skip-browser-warning": true,
      },
    });

    return {
      data: data.data?.data,
      length: data.data?.totalCount,
    };
  } catch (err) {
    const errors = err as AxiosError;
    const error = errors.response?.data as ErrorMessage;
    handleApiError(error, "Get Publication fail");
    return rejectWithValue(error);
  }
});

// update
export const updatePublicationAsync = createAsyncThunk<
  null,
  PostRequest<CreateContentData, GetSingleDataParams>
>(
  "admin/updatePublication",
  async ({ data, others: { reRender, id } }, { rejectWithValue }) => {
    try {
      await AXIOS.patch(`${BASE_API.updatePublication}/${id}`, data, {
        headers: {
          "ngrok-skip-browser-warning": true,
        },
      });

      reRender && reRender(true);
      toast("success", "Publication update successfully");
      return null;
    } catch (err) {
      const errors = err as AxiosError;
      const error = errors.response?.data as ErrorMessage;
      handleApiError(error, "Publication update fail");
      return rejectWithValue(error);
    }
  }
);

// single
export const singPublicationAsync = createAsyncThunk<
  GetSingleContentData,
  Params<GetSingleDataParams>
>("admin/singPublication", async ({ params }, { rejectWithValue }) => {
  try {
    const data = await AXIOS.get(
      `${BASE_API.getSinglePublication}/${params?.id}`,
      {
        headers: {
          "ngrok-skip-browser-warning": true,
        },
      }
    );

    return data.data?.data;
  } catch (err) {
    const errors = err as AxiosError;
    const error = errors.response?.data as ErrorMessage;
    handleApiError(error, "Single Publication data get fail");
    return rejectWithValue(error);
  }
});
